<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reject-btn.btn {
  background: #fff2f4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #fb2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.pass-btn.btn {
  background: #f2fff5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1ba854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #ff991c;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #f5f5f5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
.button-area{
  display: flex;
  justify-content:space-between;
  align-items: center
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- search start -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">开票方&nbsp;&nbsp;&nbsp;</div>
          <el-select size="mini" class="ipt-sty" v-model="page.invoiceTenantGuid" placeholder="请选择" filterable>
            <el-option v-for="item in invoiceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">收票方&nbsp;&nbsp;&nbsp;</div>
          <el-select size="mini" class="ipt-sty" v-model="page.receiveTenantGuid" placeholder="请选择" filterable>
            <el-option v-for="item in receiveTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">开票日期</div>
          <!-- <el-date-picker size="mini" class="ipt-sty" type="date" placeholder="请选择"
              v-model="page.invoiceDate"></el-date-picker> -->
          <el-date-picker
            size="mini"
            v-model="invoiceDate"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">对应款项</div>
          <el-select size="mini" class="ipt-sty" v-model="page.counterpartGuid" placeholder="请选择" filterable>
            <el-option
              v-for="item in getCodeListByKey('对应款项')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">回款状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.paymentCollectionStatus" placeholder="请选择" filterable>
            <el-option
              v-for="item in paymentCollectionStatusList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <!-- search end -->

    <!-- table start -->
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <div class="button-area">
        <div>
          <el-button v-if="getBtnPermissionsByName('新增发票信息')" icon="el-icon-plus" size="mini" type="info" @click="addVersion">新增发票信息</el-button>
        <el-button v-if="getBtnPermissionsByName('导出')" size="mini" type="info" @click="bitchExport" v-loading.fullscreen.lock="fullscreenLoading"
          >导出</el-button>
        </div>
        <div v-if="totalLoading">
          <span style="color: #FF5F1F;">正在合计中...</span>
        </div>
        <div v-else>
          <span style="margin-right: 6px;">合计开票金额：<span>{{  amountSumOne | numDigit }}</span>&nbsp;元</span>
          <span>合计回款金额：<span>{{ amountSumTwo | numDigit }}</span>&nbsp;元</span>
        </div>
      </div>
      <el-table
        ref="tableRef"
        :height="tableHeight"
        :data="tableData"
        stripe
        border
        style="width: 100%"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          label="开票方"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="210"
        >
          <template slot-scope="scope">{{ scope.row.invoiceTenantName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="收票方"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="210"
        >
          <template slot-scope="scope">{{ scope.row.receiveTenantName || '-' }}</template>
        </el-table-column>
        <el-table-column width="120" prop="createTime" label="开票日期" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.invoiceDate | getDate }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          width="120"
          label="对应款项"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ getName(scope.row.counterpartGuid, '对应款项') }}</template>
        </el-table-column>
        <el-table-column prop="invoiceAccount" width="120" label="开票金额(元)" header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.invoiceAccount | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          width="120"
          label="回款状态"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.paymentCollectionStatus | getPaymentCollectionStatus }}</template>
        </el-table-column>
        <el-table-column
          prop="receiveAmountSum"
          width="120"
          label="回款金额"
          show-overflow-tooltip
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">{{ scope.row.receiveAmountSum | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          width="120"
          label="发票类型"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ getName(scope.row.invoiceOptions, '发票选项') }}</template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          width="180"
          label="发票类目"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ getName(scope.row.invoiceCategory, '发票类目')  }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="操作人" width="120" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateUserName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" width="140" label="操作时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getTime }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="数据来源" min-width="96" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.sourceType | sourceTypeFilter }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="140" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <div>
              <a  class="txt-color" v-if="getBtnPermissionsByName('编辑')" @click="editForm(scope.row.guid, scope.$index)">编辑&nbsp;&nbsp;</a>
              <a  class="txt-color" v-if="getBtnPermissionsByName('详情')" @click="lookForm(scope.row.guid, scope.$index)">详情&nbsp;&nbsp;</a>
              <a class="txt-color" v-if="scope.row.createUserId === userinfo.userGuid||getBtnPermissionsByName('删除')" @click="delForm(scope.row.guid)"
                >删除</a
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- table end -->
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import btnPermisson from '../mixins/btnPermisson';
export default {
  mixins:[btnPermisson],
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo: userinfo,
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      totalLoading:true,
      tableData: [],
      invoiceDate: [], // 开票日期
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        invoiceTenantGuid: '', //开票方
        receiveTenantGuid: '', //收票方
        counterpartGuid: '', //对应款项
        startDate: '',
        endDate: '',
        serviceTenantGuid: localStorage.guid,
      },
      invoiceTenantList: [],
      receiveTenantList: [],
      paymentCollectionStatusList: [
        //回款状态list
        {
          text: '待回款',
          value: 'N',
        },
        {
          text: '已回款',
          value: 'Y',
        },
        {
          text: '已对冲',
          value: 'H',
        },
      ],
      AmountSumOne:'',//合计开票金额
      AmountSumTwo:'',//合计回款金额
    };
  },
  filters: {
    getPaymentCollectionStatus(val) {
      let obj = {
        Y: '已回款',
        N: '待回款',
        H: '已对冲',
      };
      return obj[val] || '-';
    },
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/upstreamInvoiceEdit') {
      next((vm) => {
        vm.getList(() => {
          if (vm.$store.getters.getPageY) vm.tableScrollToRow(vm.$refs.tableRef, vm.$store.getters.getPageY); // 表格行跳转
        });
      });
    } else {
      next();
    }
  },
  activated() {
    this.getList();
    this.getInvoiceTenantList();
    this.getReceiveTenantList();
  },
  created() {
    this.getMenuList(); // 获取按钮配置
    this.getList();
    this.getInvoiceTenantList();
    this.getReceiveTenantList();
  },
  methods: {
    getSumAmount(list,attr) {
      let sum = 0;
      list.forEach(item => {
        // sum += item.settleAmount;
        sum += Math.round(item[attr] * 100) / 100 ;
      })
      return sum
    },
    //批量导出
    bitchExport() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        invoiceTenantGuid: this.page.invoiceTenantGuid, // #开票方
        receiveTenantGuid: this.page.receiveTenantGuid, // #收票方
        counterpartGuid: this.page.counterpartGuid,
        endDate: this.page.endDate,
        startDate: this.page.startDate,
        serviceTenantGuid: localStorage.guid,
      };
      self.fullscreenLoading = true;
      self.api.postJsonD(`/${serverConfig.msCustomerService}/upstream-invoice-info/export`, req).then((res) => {
        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let fileName = '上游发票信息' + this.$moment(new Date()).format('YYYYMMDD');
        let objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = fileName;
        link.href = objectUrl;
        link.click();
        self.fullscreenLoading = false;
      });
    },
    //获取开票方
    getInvoiceTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.invoiceTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取收票方
    getReceiveTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.receiveTenantList = [];
            res.data.data.forEach((item) => {
              self.receiveTenantList.push({
                guid: item.sendTenantGuid,
                tenantName: item.sendTenantName,
              });
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    search() {
      let self = this;
      this.page.serviceTenantGuid = localStorage.guid;
      this.page.startDate = this.invoiceDate[0] || '';
      this.page.endDate = this.invoiceDate[1] || '';
      this.getAmount()
      this.page.pageIndex = 1;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/upstream-invoice-info/pageQuery`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAmount() {
      let self = this;
      let req=JSON.parse(JSON.stringify(this.page))
      req.pageSize=-1
      req.pageIndex = 1;
      self.totalLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/upstream-invoice-info/amount-sum`, req).then((res) => {
        self.totalLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.amountSumOne = res.data.data.amountSumOne;
          self.amountSumTwo = res.data.data.amountSumTwo;
          self.$forceUpdate()
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.invoiceDate = [];
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        invoiceTenantGuid: '', //开票方
        receiveTenantGuid: '', //收票方
        counterpartGuid: '', //对应款项
        startDate: '',
        endDate: '',
        serviceTenantGuid: localStorage.guid,
      };
      this.getList();
    },
    addVersion() {
      this.$router.push('/upstreamInvoiceEdit?productGuid=' + this.$route.query.productGuid);
    },
    editForm(guid, index) {
      this.setPageIndex(index);
      this.$router.push('/upstreamInvoiceEdit?guid=' + guid + '&productGuid=' + this.$route.query.productGuid);
    },
    lookForm(guid, index) {
      this.setPageIndex(index);
      this.$router.push({
        path: '/upstreamInvoiceEdit',
        query: {
          guid: guid,
          operationMode: 'look',
          productGuid: this.$route.query.productGuid,
        },
      });
    },
    setPageIndex(index) {
      this.$store.commit('setPageY', index);
    },
    getList(callBack) {
      let self = this;
      this.getAmount()
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/upstream-invoice-info/pageQuery`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          self.$nextTick(() => {
            if (callBack) callBack();
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //删除
    delForm(guid) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msCustomerService}/upstream-invoice-info/del?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    /**
     *  el-table滚动到表格某一行
     *  @param {object} tableElement  表格元素(this.$refs['表格ref值'])
     *  @param {Number} rowIndex   滚动到第几行(从0开始)
     */
    tableScrollToRow(tableElement, rowIndex) {
      const theTableRows = tableElement.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row');
      let scrollTop = 0;
      for (let i = 0; i < theTableRows.length; i++) {
        if (i === rowIndex) {
          break;
        }
        scrollTop += theTableRows[i].offsetHeight;
      }
      tableElement.bodyWrapper.scrollTop = scrollTop;
    },
  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>
